module.exports = __webpack_public_path__ + "static/img/login_logo.18b9f0a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/login_logo.svg
// module id = Unev
// module chunks = 1